import { render, staticRenderFns } from "./PresetTemplateSettings.vue?vue&type=template&id=4d3676d4&"
import script from "./PresetTemplateSettings.vue?vue&type=script&lang=ts&"
export * from "./PresetTemplateSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports